app.service('operatorMaxInstalment',function(pageConfig, console) {
	var $self, $expectedRate, $remainingWorthOnline, $remainingWorthOffline;
	var instalmentDuration=0;

	function prepare(duration) {
		if(duration){
			instalmentDuration=duration;
		}
		if($expectedRate.val()==''){
			clearRemainingWorth();
			return;
		}
		if($self.length) {
			//cena produktów w koszyku - KP jest cache'owana więc nie może tego zwracać backend
			var basketSummaryPrice = typeof pageConfig.getData('basket').summary === 'undefined' ? 0 : pageConfig.getData('basket').summary.price;
			//jeśli w koszyku coś jest - usuń whitespace bo backend wrzuca w ceny &nbsp; oraz zamień przecinki na kropki
			if(basketSummaryPrice !== 0) {
				basketSummaryPrice = basketSummaryPrice.toString().replace(/\s/g, '').replace(',', '.');
			}
			basketSummaryPrice=Number(basketSummaryPrice);


			//wartość koszyka = cena produktu na obecnej KP + to co jest już w koszyku
			var productPrice=Number($self.data('product-price').toString().replace(/\s/g, ''));


			var cartWorth = productPrice + basketSummaryPrice;
			//max wartość koszyka zależna od typu rat
			var maxCartWorthOnline = Number(($self.data('max-cart-worth-online') || '').toString().replace(/\s/g, ''));
			var maxCartWorthOffline = Number(($self.data('max-cart-worth-offline') || '').toString().replace(/\s/g, ''));
			//zamiana , na . aby nie otrzymać NaN
			var expectedWorth = Number($expectedRate.val().replace(',', '.'));
			var error1=error2=null;

			if($remainingWorthOnline.length){
				error1=calculate({
					cartWorth: cartWorth,
					maxCartWorth: maxCartWorthOnline,
					expectedWorth: expectedWorth,
					$remainingWorth: $remainingWorthOnline
				});
			}
			if($remainingWorthOffline.length){
				error2=calculate({
					cartWorth: cartWorth,
					maxCartWorth: maxCartWorthOffline,
					expectedWorth: expectedWorth,
					$remainingWorth: $remainingWorthOffline
				});
			}
			error(error1, (error2===null)?$self:$('.field-online'));
			error(error2, (error1===null)?$self:$('.field-offline'));

		}
	}
	function calculate(params){
		var cartWorth = params.cartWorth;
		var maxCartWorth = params.maxCartWorth;
		var expectedWorth = params.expectedWorth;
		var $remainingWorth = params.$remainingWorth;

		//max ile jeszcze użytkownik może dodać do koszyka = długość rat * oczekiwana rata - cena produktu - cena produktów w koszyku
		var remainingWorth = instalmentDuration * expectedWorth - cartWorth;
		//flaga sprawdzająca czy rata jaką użytkownik może zapłacić * ilość rat jest mniejsza od max wartości koszyka
		var highExpectedWorth = expectedWorth * instalmentDuration > maxCartWorth ? true : false;
		//jeśli wartość koszyka + ile jeszcze użytkownik może dodać > max wartość koszyka
		//granicą maksymalną jest max wartość koszyka
		if(cartWorth + remainingWorth > maxCartWorth) {
			//ile jeszcze użytkownik może dodac = max wartość koszyka - wartość koszyka
			remainingWorth = maxCartWorth - cartWorth;
		}
		$remainingWorth.val(remainingWorth.toFixed(2));
		console.log(cartWorth, maxCartWorth, expectedWorth, remainingWorth, $remainingWorth);
		//jeśli max ile jeszcze można dodać do koszyka jest ujemne - oczekiwana rata jest za mała
		var error=false;
		if(expectedWorth>0 && remainingWorth < 0) {
			error='low-rate-error';
		} else if (expectedWorth>0 && highExpectedWorth) {
			error='over-max-rate-error';
		}

		return error;
	}
	function error(error, $box){
		$box.removeClass('low-rate-error over-max-rate-error');
		if(error){
			if(error=='low-rate-error') {
				$box.addClass('low-rate-error');
			}
			if(error=='over-max-rate-error') {
				$box.addClass('over-max-rate-error');
			}
		}
	}
	function getData(){
		return $expectedRate.val() || 0;
	}
	function clear(){
		$expectedRate.val('');
		clearRemainingWorth();
	}
	function clearRemainingWorth(){
		$remainingWorthOnline.val('');
		$remainingWorthOffline.val('');
	}
	function setEvents(){
		clearRemainingWorth();
		$expectedRate.val('').on('keyup', function() {
			prepare();
		});
		$(document).on('cartReady',function(event,data){
			clearRemainingWorth();
			prepare();
		});
	}
	function setElements() {
		$self = $('#instalment-calculator');
		$expectedRate = $('#expected-rate');
		$remainingWorthOnline = $('#remaining-worth-online');
		$remainingWorthOffline = $('#remaining-worth-offline');
	}
	function init(){
		setElements();
		setEvents();
	}
	return {
		init, getData, clear, prepare
	};
});
